import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CONFIG_URLS_API } from 'src/environments/config-envs';
import { environment } from '../../../environments/environment';
import { LocalStorageService } from '../../services/localstorage.service';
import { ToolsService } from '../../services/tools.service';
import {
  AlteracaoCombustivel,
  DadosUsuario,
  NomeCombustivel,
} from '../model/AlteracaoCombustivel';
import {
  Combustiveis,
  RetornoGetCombustiveis,
} from '../model/RetornoGetCombustiveis';
import { AlteracaoPreco } from '../mostrar-preco/mostrar-preco.component';

@Component({
  selector: 'app-corpo',
  templateUrl: './corpo.component.html',
  styleUrls: ['./corpo.component.scss'],
})
export class CorpoComponent implements OnInit {
  loading: boolean | false = false;
  combustivelSelecionado: string = 'S';

  statusSucesso: string | 'alert-success' = 'alert-success';
  mensagens: string[] | [] = [];
  private tipoDesconto: string | 'descporcentagem' = 'descporcentagem';
  usuario: DadosUsuario | null = null;

  retornoGetCombustiveis: RetornoGetCombustiveis | null = null;
  combustivel: Combustiveis | null = null;
  copiaCombustivel: Combustiveis | null = null;

  tipoPrecoSendoAlterado: string | 'precoUnitario' = 'precoUnitario';

  @ViewChild('content', { static: true }) private content: any;
  precosCombustiveisDesatualizados?: boolean;
  listaCombustiveis: NomeCombustivel[] = [];

  private localStorageService = inject(LocalStorageService);
  private toolsService = inject(ToolsService<any>);
  private modalService = inject(NgbModal);

  ngOnInit(): void {
    this.getDadosUsuario();
  }

  async getTiposCombustiveis() {
    try {
      let ret = await this.toolsService.get(
        environment.host_ctf_service +
          CONFIG_URLS_API.API_ConsultaListaCombustiveis +
          this.usuario?.guid
      );
      if (ret.sucesso) {
        this.listaCombustiveis = ret.retorno.filter(
          (x: { descricaoCombustivel: string }) => x.descricaoCombustivel != ''
        );
        this.listaCombustiveis = this.listaCombustiveis.sort(
          (a, b) => a.codigoCombustivel - b.codigoCombustivel
        );
      } else {
        console.log('Erro no retorno da api: ' + ret.mensagens);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getDadosUsuario() {
    try {
      var userData = this.localStorageService.getItem('userData');
      let u = JSON.parse(userData);

      let d: DadosUsuario = {
        guid: u.retorno.guid,
        codPosto: u.retorno.codigoEntidade,
        dscemail: u.retorno.email,
        dsctelefone: u.retorno.celular,
        dsclogin: u.retorno.login,
        tipo: u.retorno.tipo,
      };

      if (userData !== null || u.guid !== null) {
        this.usuario = d;

        await this.getTiposCombustiveis();
        this.getPrices();
        //this.verificarPrecosDesatualizados();
      } else {
        this.statusSucesso = 'alert-danger';
        this.mensagens = ['Erro nos dados de consulta do usuário!'];
      }
    } catch (error) {
      this.statusSucesso = 'alert-danger';
      this.mensagens = ['Erro nos dados do usuário!'];
    }
  }

  async getPrices() {
    this.loading = true;

    this.tipoDesconto = this.localStorageService.getItem('tipoDesconto');
    if (this.tipoDesconto == null) this.tipoDesconto = 'descporcentagem';

    try {
      let dadosCombustivel = await this.toolsService.post(
        environment.host_ctf_service + CONFIG_URLS_API.API_ConsultaDePreco,
        JSON.stringify({
          codPosto: this.usuario?.codPosto,
          guid: this.usuario?.guid,
        })
      );
      if (dadosCombustivel.sucesso) {
        let comb = JSON.parse(dadosCombustivel.retorno.response);

        if (comb.some((x: Combustiveis) => x.redeEspecial)) {
          for (let c of comb) {
            let precoTela = c.combustivel.precos.precoUnitario[0].preco;
            let sps = c.combustivel.precos.precoNegociado[0].preco;
            let redeEspecial = c.combustivel.precos.precoRedeEspecial[0].preco;

            if (precoTela) {
              if (sps > precoTela) {
                c.combustivel.precos.precoNegociado[0].preco = precoTela;
                c.combustivel.precos.precoNegociado[0].descontoCentavos =
                  precoTela - sps;
                c.combustivel.precos.precoNegociado[0].descontoPercentual =
                  ((precoTela - sps) / precoTela) * 100;
                sps = precoTela;

                if (redeEspecial > sps) {
                  c.combustivel.precos.precoRedeEspecial[0].preco = sps;
                  c.combustivel.precos.precoRedeEspecial[0].descontoCentavos =
                    precoTela - sps;
                  c.combustivel.precos.precoRedeEspecial[0].descontoCentavos =
                    ((precoTela - sps) / precoTela) * 100;

                  redeEspecial = sps;
                }
              }

              if (redeEspecial > precoTela || redeEspecial > sps) {
                c.combustivel.precos.precoRedeEspecial[0].preco = precoTela;
                c.combustivel.precos.precoRedeEspecial[0].descontoCentavos = 0;
                redeEspecial = precoTela;

                if (redeEspecial > sps) {
                  c.combustivel.precos.precoRedeEspecial[0].preco = sps;
                  c.combustivel.precos.precoRedeEspecial[0].descontoCentavos =
                    precoTela - sps;
                  redeEspecial = sps;
                }
              }
            }
          }
        }

        this.retornoGetCombustiveis = comb;

        this.combustivelAlterado(this.combustivelSelecionado);
      } else {
        this.statusSucesso = 'alert-danger';
        this.mensagens = dadosCombustivel.mensagens;
      }
    } catch (e) {
      this.statusSucesso = 'alert-danger';
      this.mensagens = ['Erro no recebimento dos dados!'];
    }

    this.loading = false;
  }

  getPostAlteracaoCombustivel(): AlteracaoCombustivel {
    if (this.tipoPrecoSendoAlterado === 'precoUnitario') {
      return {
        guid: this.usuario?.guid || '',
        codPosto: this.usuario?.codPosto || 0,
        dsclogin: this.usuario?.dsclogin || '',
        dscemail: this.usuario?.dscemail || '',
        dsctelefone: this.usuario?.dsctelefone || '',
        tipo: this.usuario?.tipo || 0,
        combustivel: {
          indCombustivel: this.combustivel?.indCombustivel || '',
          descricaoCombustivel: this.combustivel?.descricaoCombustivel || '',
          precoNovo: {
            descricao:
              this.combustivel?.combustivel.precos.precoUnitario[0].descricao ||
              '',
            valor:
              this.combustivel?.combustivel.precos.precoUnitario[0].preco || 0,
          },
          descontoCentavos: {
            descricao: 'Desconto em Reais',
            valor: this.combustivel?.combustivel.precos.descontoEmReais || 0,
          },
          descontoPercentual: {
            descricao: 'Desconto porcentual',
            valor:
              this.combustivel?.combustivel.precos.descontoEmPorcentagem || 0,
          },
          precoNegociado: {
            descricao:
              this.combustivel?.combustivel.precos.precoNegociado[0]
                .descricao || '',
            valor:
              this.combustivel?.combustivel.precos.precoNegociado[0].preco || 0,
          },
          precoRedeEspecial: {
            descricao:
              this.combustivel?.combustivel.precos.precoRedeEspecial[0]
                .descricao || '',
            valor:
              this.combustivel?.combustivel.precos.precoRedeEspecial[0]
                .vlrDesconto || 0,
          },

          precoPrazo: {
            descricao: 'Preço a prazo',
            valor:
              this.combustivel?.combustivel.precos.precoUnitario[0].preco || 0,
          },
          precoUnitario: {
            descricao:
              this.combustivel?.combustivel.precos.precoUnitario[0].descricao ||
              '',
            valor:
              this.combustivel?.combustivel.precos.precoUnitario[0].preco || 0,
          },
          precoAnterior: {
            descricao:
              this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                .descricao || '',
            valor:
              this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                .preco || 0,
          },
          disponivelParaVenda: this.combustivel?.disponivelParaVenda || 0,
        },
      };
    } else {
      return {
        guid: this.usuario?.guid || '',
        codPosto: this.usuario?.codPosto || 0,
        dsclogin: this.usuario?.dsclogin || '',
        dscemail: this.usuario?.dscemail || '',
        dsctelefone: this.usuario?.dsctelefone || '',
        tipo: this.usuario?.tipo || 0,
        combustivel: {
          indCombustivel: this.combustivel?.indCombustivel || '',
          descricaoCombustivel: this.combustivel?.descricaoCombustivel || '',
          precoNovo: {
            descricao:
              this.combustivel?.combustivel.precos.precoUnitario[0].descricao ||
              '',
            valor:
              this.combustivel?.combustivel.precos.precoUnitario[0].preco || 0,
          },
          descontoCentavos: {
            descricao: 'Desconto em Reais',
            valor: this.combustivel?.combustivel.precos.descontoEmReais || 0,
          },
          descontoPercentual: {
            descricao: 'Desconto porcentual',
            valor:
              this.combustivel?.combustivel.precos.descontoEmPorcentagem || 0,
          },
          precoNegociado: {
            descricao:
              this.combustivel?.combustivel.precos.precoNegociado[0]
                .descricao || '',
            valor:
              this.combustivel?.combustivel.precos.precoNegociado[0].preco || 0,
          },

          precoRedeEspecial: {
            descricao:
              this.combustivel?.combustivel.precos.precoRedeEspecial[0]
                .descricao || '',
            valor:
              this.combustivel?.combustivel.precos.precoRedeEspecial[0]
                .vlrDesconto || 0,
          },

          precoPrazo: {
            descricao: 'Preço a prazo',
            valor:
              this.combustivel?.combustivel.precos.precoUnitario[0].preco || 0,
          },
          precoUnitario: {
            descricao:
              this.combustivel?.combustivel.precos.precoUnitario[0].descricao ||
              '',
            valor:
              this.combustivel?.combustivel.precos.precoUnitario[0].preco || 0,
          },
          precoAnterior: {
            descricao:
              this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                .descricao || '',
            valor:
              this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                .preco || 0,
          },
          disponivelParaVenda: this.combustivel?.disponivelParaVenda || 0,
        },
      };
    }
  }

  async salvarPrecos(comb?: AlteracaoCombustivel) {
    let alteracaoCombustivel =
      comb == null ? this.getPostAlteracaoCombustivel() : comb;

    console.log(alteracaoCombustivel);

    if (!this.combustivel?.redeEspecial)
      alteracaoCombustivel.combustivel.precoRedeEspecial = null;

    this.combustivelSelecionado = this.combustivel?.indCombustivel || 'S';

    try {
      let ret = await this.toolsService.post(
        environment.host_ctf_service + CONFIG_URLS_API.API_CadastroDePreco,
        JSON.stringify(alteracaoCombustivel)
      );
      //let ret = await this.toolsService.post('http://localhost:3004/criarOuAtualizar', JSON.stringify(alteracaoCombustivel));

      if (ret.sucesso === true && ret.mensagens.length === 0) {
        let retono = JSON.parse(ret.retorno.response)[0];

        if (retono.COD_RETORNO === 0) {
          if (comb == null) {
            this.statusSucesso = 'alert-success';
            this.mensagens = [
              `Dados do combustivel ${this.combustivel?.descricaoCombustivel} atualizado com sucesso!`,
            ];
            this.getPrices();
          }
        } else {
          this.statusSucesso = 'alert-danger';
          this.mensagens = retono.DSC_RETORNO.split('</br>');
        }
      } else {
        this.statusSucesso = 'alert-danger';
        this.mensagens = ret.mensagens;
      }
    } catch (e) {
      //console.log(e)
      this.statusSucesso = 'alert-danger';
      // @ts-ignore
      this.mensagens = [e];
    } finally {
      this.loading = false;
    }
  }

  combustivelAlterado(combustivelSelecionado: string = 'S') {
    if (this.retornoGetCombustiveis !== null) {
      let comb = this.retornoGetCombustiveis?.find(
        (x) => x.indCombustivel === combustivelSelecionado
      );
      this.combustivel = comb == undefined ? null : comb;
      this.copiaCombustivel = JSON.parse(JSON.stringify(comb));
    } else {
      this.statusSucesso = 'alert-danger';
      this.mensagens = ['Lista de combustiveis vazia!'];
    }
  }

  alterarPrecoCombustivel(comb: AlteracaoPreco) {
    this.tipoPrecoSendoAlterado = comb.tipoDeAlteracao;
    this.combustivel = comb.combustivel;
    this.openModalDialog();
  }

  salvarMods(salvarMudancas: boolean) {
    if (salvarMudancas) {
      this.salvarPrecos();
      this.loading = true;
    } else {
      this.restaurarCombustivelSemMudancas();
    }

    this.modalService.dismissAll();
  }

  private restaurarCombustivelSemMudancas(): void {
    this.combustivel = this.copiaCombustivel;
    this.copiaCombustivel = JSON.parse(JSON.stringify(this.combustivel));
  }

  private getDismissReason(reason: any): string {
    this.restaurarCombustivelSemMudancas();

    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openModalDialog() {
    this.modalService
      .open(this.content, {
        windowClass: 'custom-window-class',
        ariaLabelledBy: 'modal-basic-title',
      })
      .result.then(
        (result) => {
          //console.log(result)
        },
        (reason) => {
          this.getDismissReason(reason);
        }
      );
  }

  async verificarPrecosDesatualizados() {
    try {
      let ret = await this.toolsService.post(
        environment.host_ctf_service +
          CONFIG_URLS_API.API_NecessitaAtualizacaoPrecos,
        { userGuid: this.usuario?.guid }
      );
      if (ret.sucesso) {
        this.precosCombustiveisDesatualizados = ret.retorno;
      } else {
        this.statusSucesso = 'alert-danger';
        this.mensagens = ret.mensagens;
      }
    } catch (e) {
      this.statusSucesso = 'alert-danger';
      this.mensagens = ['Erro no recebimento dos dados!'];
    }
  }

  async confirmarPrecosAtuais() {
    if (this.retornoGetCombustiveis) {
      this.loading = true;

      for (const comb of this.retornoGetCombustiveis) {
        this.copiaCombustivel = comb;

        var comprecoValido =
          this.copiaCombustivel.combustivel.precos.precoUnitario[0].preco !=
            undefined &&
          this.copiaCombustivel.combustivel.precos.precoUnitario[0].preco != 0;

        if (comprecoValido) {
          try {
            var cp: AlteracaoCombustivel = {
              guid: this.usuario?.guid || '',
              codPosto: this.usuario?.codPosto || 0,
              dsclogin: this.usuario?.dsclogin || '',
              dscemail: this.usuario?.dscemail || '',
              dsctelefone: this.usuario?.dsctelefone || '',
              tipo: this.usuario?.tipo || 0,
              combustivel: {
                indCombustivel: this.copiaCombustivel?.indCombustivel || '',
                descricaoCombustivel:
                  this.copiaCombustivel?.descricaoCombustivel || '',
                precoNovo: {
                  descricao:
                    this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                      .descricao || '',
                  valor:
                    this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                      .preco || 0,
                },
                descontoCentavos: {
                  descricao: 'Desconto em Reais',
                  valor:
                    (this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                      .preco || 0) -
                    (this.copiaCombustivel?.combustivel.precos.precoNegociado[0]
                      .preco || 0),
                },
                descontoPercentual: {
                  descricao: 'Desconto porcentual',
                  valor: 0,
                },
                precoNegociado: {
                  descricao:
                    this.copiaCombustivel?.combustivel.precos.precoNegociado[0]
                      .descricao || '',
                  valor:
                    this.copiaCombustivel?.combustivel.precos.precoNegociado[0]
                      .preco || 0,
                },
                precoRedeEspecial: {
                  descricao:
                    this.copiaCombustivel?.combustivel.precos
                      .precoRedeEspecial[0].descricao || '',
                  valor:
                    this.copiaCombustivel?.combustivel.precos
                      .precoRedeEspecial[0].vlrDesconto || 0,
                },
                precoPrazo: {
                  descricao: 'Preço a prazo',
                  valor:
                    this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                      .preco || 0,
                },
                precoUnitario: {
                  descricao:
                    this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                      .descricao || '',
                  valor:
                    this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                      .preco || 0,
                },
                precoAnterior: {
                  descricao:
                    this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                      .descricao || '',
                  valor:
                    this.copiaCombustivel?.combustivel.precos.precoUnitario[0]
                      .preco || 0,
                },
                disponivelParaVenda:
                  this.copiaCombustivel?.disponivelParaVenda || 0,
              },
            };
            await this.salvarPrecos(cp);
          } catch (e) {
            this.statusSucesso = 'alert-danger';
            this.mensagens = ['Erro no recebimento dos dados!'];
          }
        }
      }

      this.statusSucesso = 'alert-success';
      this.mensagens = [`Dados dos combustíveis atualizados com sucesso!`];

      this.precosCombustiveisDesatualizados = false;
    }

    this.loading = false;
  }

  async habilitarDesabilitarCombustivel(dto: Combustiveis) {
    try {
      let a: AlteracaoCombustivel = {
        combustivel: {
          indCombustivel: dto.indCombustivel,
          descricaoCombustivel: dto.descricaoCombustivel,
          precoAnterior: {
            descricao: dto.combustivel.precos.precoUnitario[0].descricao,
            valor: dto.combustivel.precos.precoUnitario[0].preco || 0,
          },
          precoNovo: {
            descricao: dto.combustivel.precos.precoUnitario[0].descricao,
            valor: dto.combustivel.precos.precoUnitario[0].preco || 0,
          },
          descontoCentavos: {
            descricao: 'Desconto em Reais',
            valor: dto.combustivel.precos.descontoEmReais || 0,
          },
          descontoPercentual: {
            descricao: 'Desconto porcentual',
            valor: dto.combustivel.precos.descontoEmPorcentagem || 0,
          },
          precoNegociado: {
            descricao: dto.combustivel.precos.precoNegociado[0].descricao,
            valor: dto.combustivel.precos.precoNegociado[0].preco,
          },
          precoRedeEspecial: {
            descricao: dto.combustivel.precos.precoRedeEspecial[0].descricao,
            valor: dto.combustivel.precos.precoRedeEspecial[0].vlrDesconto || 0,
          },
          precoPrazo: {
            descricao: 'Preço a prazo',
            valor: dto.combustivel.precos.precoUnitario[0].preco || 0,
          },
          precoUnitario: {
            descricao: dto.combustivel.precos.precoUnitario[0].descricao,
            valor: dto.combustivel.precos.precoUnitario[0].preco || 0,
          },
          disponivelParaVenda: dto.disponivelParaVenda,
        },
        codPosto: this.usuario?.codPosto || 0,
        dscemail: this.usuario?.dscemail || '',
        dsclogin: this.usuario?.dsclogin || '',
        dsctelefone: this.usuario?.dsctelefone || '',
        guid: this.usuario?.guid || '',
        tipo: this.usuario?.tipo || 0,
      };
      this.mensagens = [];
      this.loading = true;

      let ret = await this.toolsService.post(
        environment.host_ctf_service + CONFIG_URLS_API.API_CadastroDePreco,
        JSON.stringify(a)
      );
      if (ret.sucesso === true && ret.mensagens.length === 0) {
        let retono = JSON.parse(ret.retorno.response)[0];

        if (retono.COD_RETORNO === 0) {
          this.statusSucesso = 'alert-success';
          dto.disponivelParaVenda
            ? (this.mensagens = [
                `Combustivel ${dto.descricaoCombustivel} habilitado com sucesso!`,
              ])
            : (this.mensagens = [
                `Combustivel ${dto.descricaoCombustivel} desabilitado com sucesso!`,
              ]);
          this.getPrices();
          this.combustivelSelecionado = dto.indCombustivel;
        } else {
          this.statusSucesso = 'alert-danger';
          this.mensagens = retono.DSC_RETORNO.split('</br>');
        }
      } else {
        this.statusSucesso = 'alert-danger';
        this.mensagens = ret.mensagens;
      }
    } catch (e) {
      this.statusSucesso = 'alert-danger';
      // @ts-ignore
      this.mensagens = [e];
    } finally {
      this.loading = false;
    }
  }
}
